import { Box, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { useMinimalsTheme } from '../../../hooks'

interface Props {
  label: string
  labelIcon?: ReactNode
  required?: boolean
  rightRender: ReactNode
  hasDivider?: boolean
  hasError?: boolean
  children?: ReactNode
  titleColor?: string
  displayChildren?: boolean
}
export const FieldBox = ({
  label,
  labelIcon,
  required,
  rightRender,
  hasDivider,
  hasError,
  children,
  titleColor,
  displayChildren = true,
}: Props) => {
  const theme = useMinimalsTheme()

  return (
    <Card
      variant='outlined'
      sx={{
        boxShadow: 'none',
        width: '100%',
        border: `1px solid ${hasError ? theme.palette.error.main : theme.palette.grey[300]}`,
      }}
    >
      <CardHeader
        title={
          <Stack flexDirection='row' gap={0.5} alignItems='center'>
            {labelIcon && <Box marginRight={1}>{labelIcon}</Box>}
            <Typography variant='subtitle2' color={titleColor}>
              {label}{' '}
            </Typography>{' '}
            {required && (
              <Typography variant='subtitle2' color='error'>
                *
              </Typography>
            )}
          </Stack>
        }
        action={rightRender}
        sx={{
          paddingBottom: theme => theme.customSpacing.m,
          paddingRight: theme => theme.customSpacing.l,
        }}
      ></CardHeader>

      {children && displayChildren && (
        <CardContent
          sx={{
            borderTop: theme => (hasDivider ? `1px solid ${theme.palette.grey[300]}` : undefined),
          }}
        >
          {children}
        </CardContent>
      )}
    </Card>
  )
}
